import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=auth
  const [structureId, setStructureId] = useState(localStorage.getItem("goweb_structure") || "");

  useEffect(() => {
    const token = localStorage.getItem("goweb_token");
    if (!token) return setUser(false);
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("goweb_token", data.token);
    setUser(data.user);
    if (data.user.role !== "super_admin" && data.user.structure_id) {
      setStructureId(data.user.structure_id);
      localStorage.setItem("goweb_structure", data.user.structure_id);
    }
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("goweb_token");
    setUser(false);
    window.location.href = "/login";
  }, []);

  const selectStructure = useCallback((sid) => {
    setStructureId(sid);
    if (sid) localStorage.setItem("goweb_structure", sid);
    else localStorage.removeItem("goweb_structure");
  }, []);

  const isSuperAdmin = user && user.role === "super_admin";
  // effective structure filter for API calls
  const effectiveStructure = isSuperAdmin ? structureId : user?.structure_id || "";

  return (
    <AuthContext.Provider value={{ user, login, logout, structureId, selectStructure, isSuperAdmin, effectiveStructure }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
